import React from 'react'
import { ImageProp, LinkProp } from '../../../../common/props'
import { SlideTextContainer, SlideHeadline, SlideCaption, SlideLink } from '../style'
import { SlideContainer, MediaContainer } from './style'
import { useLaunchModalContext } from '../../../../contexts/LaunchModalContext'
import { LaunchModalMediaSize } from '../..'

const CarouselSlides: React.VFC<{
  caption?: string
  headline: string
  image: ImageProp
  index: number
  link?: LinkProp
  imageSize: LaunchModalMediaSize
  dataTaktId: string
}> = ({ caption = '', headline, image, index, link, imageSize, dataTaktId }) => {
  const { activeIndex, slidesLength } = useLaunchModalContext()
  return (
    <>
      <SlideContainer key={caption} isActive={activeIndex === index} isFirstSlide={activeIndex === 0} isLastSlide={activeIndex === slidesLength - 1}>
        <SlideTextContainer>
          <SlideHeadline type="h2">{headline}</SlideHeadline>
          <SlideCaption fontSize="medium">{caption}</SlideCaption>
          {link && (
            <SlideLink href={link.link} data-takt-id={`${dataTaktId}_slide-${index}-link`}>
              {link.label}
            </SlideLink>
          )}
        </SlideTextContainer>
        {image && <MediaContainer alt={image.altText} src={image.link} size={imageSize} />}
      </SlideContainer>
    </>
  )
}

export default CarouselSlides
